<script>
    import { result } from "../quiz/result";
    import { fade } from "svelte/transition"

    export let toggleEquation

</script>

<style>
    h1 {
        font-size: 2em;
        margin: 0.5em;
    }

    h3 {
        font-size: 1.5em;
        font-weight: 300;
        margin: 0;
    }

    .equation-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 40%;
        margin-top: 8em;
        margin-bottom: 5em;
    }

    .answer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 5em;
    }

    .equation {
        filter: invert(84%) sepia(0%) saturate(66%) hue-rotate(317deg) brightness(100%) contrast(108%);
        margin: 1em;
        width: 100%;
        max-height: 5em;
    }

	@media (max-width: 640px) {
        h1 {
            font-size: 1.5em;
            margin-top: 0.2em;
            margin-bottom: 1em;
        }

        h3 {
            font-size: 1.2em;
            font-weight: 300;
            margin: 0;
        }

		.equation-wrapper {
            justify-content: flex-start;
            margin-top: 5em;
            width: 70%;
            min-height: unset;
        }
	}
</style>


<div class="equation-wrapper" in:fade>
    {#each Object.entries(result) as [key, value]}
        <div class="answer">
            <h3>{value.name}</h3>
            <!-- <h1>{@html value.equation}</h1> -->
            <img src={`assets/equations/${key}.svg`} alt="" class="equation">
            <!-- <Formula displayMode/> -->
            <div>{value.description}</div>
        </div>
    {/each}
    <button on:click={toggleEquation}>กลับ</button>
</div>